export default "__VITE_ASSET__Dt4T18N1__"